function readFile(file) {
  return new Promise(resolve => {
    const fileReader = new FileReader();
    fileReader.onload = event => {
      resolve(event.target.result);
    };
    fileReader.readAsText(file);
  });
}

export default readFile;
